"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Award = void 0;
var vue_1 = require("vue");
var constants_1 = require("../constants");
var PreferencesManager_1 = require("./PreferencesManager");
exports.Award = vue_1.default.component('award', {
    props: {
        awards_list: {
            type: Array,
        },
        show_scores: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        var showDescription = {};
        for (var _i = 0, _a = this.awards_list; _i < _a.length; _i++) {
            var award = _a[_i];
            showDescription[award.award.name] = false;
        }
        return {
            showDescription: showDescription,
            showList: true,
        };
    },
    methods: {
        getNameCss: function (awardName) {
            return ('ma-name ma-name--' + awardName.replace(/ /g, '-').toLowerCase());
        },
        shouldShow: function (award) {
            return this.showDescription[award.award.name] === true;
        },
        shouldShowList: function () {
            return this.showList;
        },
        toggle: function (award) {
            this.showDescription[award.award.name] = !this.showDescription[award.award.name];
        },
        toggleList: function () {
            this.showList = !this.showList;
        },
        getAvailableAwardSpots: function () {
            var numFundedAwards = 0;
            this.awards_list.forEach(function (award) {
                if (award.player_name) {
                    numFundedAwards++;
                }
            });
            return constants_1.AWARD_COSTS.slice(numFundedAwards);
        },
        isLearnerModeOn: function () {
            return PreferencesManager_1.PreferencesManager.loadBoolean('learner_mode');
        },
    },
    template: "\n    <div class=\"awards_cont\" v-trim-whitespace>\n        <div class=\"awards\">\n            <div class=\"ma-title\">\n                <a class=\"ma-clickable awards-padding\" href=\"#\" v-on:click.prevent=\"toggleList()\" v-i18n>Awards</a>\n                <span v-for=\"award in awards_list\" v-if=\"award.player_name\" class=\"milestone-award-inline paid\" :title=\"award.player_name\">\n                    <span v-i18n>{{ award.award.name }}</span>\n                    <span class=\"ma-player-cube\"><i :class=\"'board-cube board-cube--'+award.player_color\" /></span>\n                </span>\n                <span v-for=\"spotPrice in getAvailableAwardSpots()\" class=\"milestone-award-inline unpaid\" v-if=\"isLearnerModeOn()\">\n                  <div class=\"milestone-award-price\">{{spotPrice}}</div>\n                </span>\n            </div>\n\n            <div v-show=\"shouldShowList()\">\n                <div title=\"press to show or hide the description\" v-on:click.prevent=\"toggle(award)\" v-for=\"award in awards_list\" class=\"ma-block\">\n                    <div class=\"ma-player\" v-if=\"award.player_name\"><i :title=\"award.player_name\" :class=\"'board-cube board-cube--'+award.player_color\" /></div>\n                    <div class=\"ma-name--awards award-block\" :class=\"getNameCss(award.award.name)\" v-i18n>\n                        {{award.award.name}}\n                        <div v-if=\"show_scores\" class=\"ma-scores player_home_block--milestones-and-awards-scores\">\n                            <p v-for=\"score in award.scores.sort(\n                                (s1, s2) => s2.playerScore - s1.playerScore\n                            )\" :class=\"'ma-score player_bg_color_'+score.playerColor\">{{ score.playerScore }}</p>\n                        </div>\n                    </div>\n                    <div v-show=\"shouldShow(award)\" class=\"ma-description\" v-i18n>{{award.award.description}}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n    ",
});
//# sourceMappingURL=Award.js.map